import React, { createContext, useReducer } from 'react'
import PropTypes from 'prop-types'

const initialState = {
  isOpen: false,
  message: '',
  status: ''
}

export const STATUS_MODAL = {
  IS_OPEN: {
    SET: 'STATUS_MODAL/IS_OPEN/SET'
  },
  MESSAGE: {
    SET: 'STATUS_MODAL/MESSAGE/SET'
  },
  STATUS: {
    SET: 'STATUS_MODAL/STATUS/SET'
  }
}

let reducer = ( state, action ) => {
  switch(action.type) {
    case "reset":
      return initialState
    case STATUS_MODAL.IS_OPEN.SET:
      return { ...state, isOpen: action.payload }
    case STATUS_MODAL.MESSAGE.SET:
      return { ...state, message: action.payload }
    case STATUS_MODAL.STATUS.SET:
      return { ...state, status: action.payload }
    default:
      return state
  }
}

export const StatusModalContext = createContext()

export const StatusModalProvider = ({ children }) => {
  let [state, dispatch] = useReducer(reducer, initialState)
  let value = { state, dispatch }

  return (
    <StatusModalContext.Provider value={ value }>
      { children }
    </StatusModalContext.Provider>
  )
}

StatusModalProvider.propTypes = {
  children: PropTypes.node
}

export const StatusModalConsumer = StatusModalContext.Consumer
